import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { UA } from '@/utils/common'

const UserAgent = UA()

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'main',
    component: () => import('../views/main.vue'),
    children: [
      {
        path: '/',
        name: 'index',
        component: () => import(/* webpackChunkName: "home" */ '../views/index.vue'),
        meta: {
          title: 'NZONE官方网站'
        }
      },

      {
        path: '/productList',
        name: 'productList',
        component: () => import(/* webpackChunkName: "productList" */ '../views/productList.vue'),
        meta: {
          title: 'NZONE官方网站'
        }
      },

      // {
      //   path: '/productList',
      //   name: 'productList',
      //   component:() => import('../views/productList.vue'),
      //   meta:{
      //     title: 'NZONE官方网站'
      //   }
      // },

      {
        path: '/productDetails/:id',
        name: 'productDetails',
        component: () => import(/* webpackChunkName: "productDetails" */ '../views/productDetails.vue'),
        meta: {
          title: 'NZONE官方网站'
        }
      },
      {
        path: '/shop',
        name: 'shop',
        component: () => import(/* webpackChunkName: "shop" */'../views/shop.vue'),
        meta: {
          title: 'NZONE官方网站'
        }
      },
      {
        path: '/query',
        name: 'query',
        component: () => import('../views/query.vue'),
        meta: {
          title: 'NZONE官方网站'
        }
      },
      {
        path: '/message',
        name: 'message',
        component: () => import('../views/message.vue'),
        meta: {
          title: 'NZONE官方网站'
        }
      },
      {
        path: '/messageTable',
        name: 'messageTable',
        component: () => import('../views/messageTable.vue'),
        meta: {
          title: 'NZONE官方网站'
        }
      },
      {
        path: '/instruction',
        name: 'instruction',
        component: () => import('../views/instruction.vue'),
        meta: {
          title: 'NZONE官方网站'
        }
      },

      {
        path: '/repair',
        name: 'repair',
        component: () => import('../views/repair.vue'),
        meta: {
          title: 'NZONE官方网站'
        }
      },

      {
        path: '/problems',
        name: 'problems',
        component: () => import('../views/problems.vue'),
        meta: {
          title: 'NZONE官方网站'
        }
      },


      {
        path: '/service',
        name: 'service',
        component: () => import('../views/service.vue'),
        meta: {
          title: 'NZONE官方网站'
        }
      },

      {
        path: '/activity',
        name: 'activity',
        component: () => import('../views/activity.vue'),
        meta: {
          title: 'NZONE官方网站'
        }
      },

      {
        path: '/activity-1',
        name: 'activity1',
        component: () => import('../views/activity1.vue'),
        meta: {
          title: 'NZONE官方网站'
        }
      }
    ]
  },

  {
    path: '/:catchAll(.*)',
    name: '/404',
    component: () => import('../views/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (UserAgent.mobile) {
    window.location.href = process.env.VUE_APP_H5_URL as string
    return
  } else {
    next()
  }
})

export default router
